import { GoodDetailParam } from '@/pages/shop/c_shop_golden/component';
import { CommonHeaders } from '@/pages/shop/c_shop_golden/utils/commonHeaders';
import { SHOPURL } from '@/pages/shop/c_shop_golden/utils/constant';

const indicatorModule = Mach.requireModule('ActivityIndicator');

export async function MultiSkuRequest(requestParam: GoodDetailParam, showMultiSkuDirectly, headers = {}): Promise<any> {
  // @ts-ignore
  const networkModule = Mach.requireModule('Network');
  //  请求loading展示时间
  const showMultiSkuDuration = 400;
  let showMultiSkuLoading = true;

  const params = {
    url: SHOPURL.MULTISKU,
    method: 'POST',
    data: requestParam,
    dataType: 'json',
    headers: {
      ...CommonHeaders.getCommonHeader(),
      ...headers
    },
  };

  const showLoading = (showMultiSkuDuration) => {
    setTimeout(() => {
      if (showMultiSkuLoading) {
        indicatorModule.showLoading();
      }
    }, showMultiSkuDuration);
  };

  // @ts-ignore
  return new Promise<any>((resolve, reject) => {
    const startTime = new Date().getTime();
    if (showMultiSkuDirectly) {
      showLoading(showMultiSkuDuration);
    } else {
      indicatorModule.showLoading();
    }
    networkModule.requestWx(params, async (result: any) => {
      if (showMultiSkuDirectly) {
        const endTime = new Date().getTime();
        const timeDiff = showMultiSkuDuration - (endTime - startTime);
        // 防止在页面展开动画（300ms）执行过程中，请求返回，页面渲染，导致闪动卡顿
        if (timeDiff > 0 && timeDiff < showMultiSkuDuration) {
          await new Promise((resolve) => setTimeout(resolve, timeDiff));
        }
        if (showMultiSkuLoading) {
          indicatorModule.hideLoading();
          showMultiSkuLoading = false;
        }
      } else {
        indicatorModule.hideLoading();
      }
      if (result.error) {
        console.log(`MultiSkuRequest request api error: ${JSON.stringify(result.error)}`);
        reject(result.error);
      } else {
        console.log('MultiSkuRequest request api success!');
        if (result.data && result.data.code === 0 && result.data.data) {
          // ----- mpweb适配origin -----
          // resolve(result.data.data);
          // ----- mpweb适配change -----
          if (window.__nol) {
            const spu = result.data.data;
            delete spu.discountPrice;
            delete spu.discountPriceList;
            delete spu.activityInfoList;
            delete spu.promotionTagInfo;
            spu.skuList = spu.skuList?.map((sku) => {
              delete sku.discountPrice;
              delete sku.discountPriceList;
              delete sku.activityInfoList;
              delete sku.promotionTagInfo;
              return ({ ...sku });
            });
            console.log('productList', spu, spu?.skuList[0]);
            resolve(spu);
          } else {
            resolve(result.data.data);
          }
          // ----- mpweb适配       -----
        } else {
          reject(result);
        }
      }
    });
  });
}
